import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/auth";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import OpenAIPartner from "@/pages/OpenAIPartner";
import { trackPageView, bindCalendlyAppointmentListener } from "@/lib/tracking";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Fire page_viewed exactly once per pathname change (also handles first mount).
    // Not tracked on /admin or /login (internal, non-marketing routes).
    if (!pathname.startsWith("/admin") && !pathname.startsWith("/login")) {
      trackPageView(pathname);
    }
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    bindCalendlyAppointmentListener();
  }, []);
  const smooth = typeof window !== "undefined" && !window.location.search.includes("nosmooth");
  const content = (
    <AuthProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/audit" element={<Navigate to="/#audit" replace />} />
          <Route path="/openai-partner" element={<OpenAIPartner />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
  return (
    <div className="App grain">
      {smooth ? (
        <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>{content}</ReactLenis>
      ) : (
        content
      )}
    </div>
  );
}

export default App;
